// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yw-b","newExpiryDate":"styles_newExpiryDate__WbbfU","footer":"styles_footer__1GLfi"};